import type { MarketingNote } from '../../../../api/venue-marketing';
import { formatAbsoluteDate } from '../../../../utils/relative-age';

import { NoteDoneLine } from './NoteDoneLine';

interface NoteTrailProps {
  note: MarketingNote;
  /** Shows a "reopen" link beside the done line. */
  onReopen?: () => void;
}

/** Who finished and who last edited a note, and when. Nothing when neither applies. */
export function NoteTrail({ note, onReopen }: NoteTrailProps) {
  const { doneAt, editedAt } = note;
  if (!doneAt && !editedAt) return null;
  return (
    <div
      style={{
        fontSize: 10.5,
        color: 'var(--nb-muted)',
        marginTop: 4,
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
      }}
    >
      {doneAt && <NoteDoneLine doneAt={doneAt} doneByName={note.doneByName} onReopen={onReopen} />}
      {editedAt && (
        <span>
          edited by {note.editedByName ?? 'a former team member'} · {formatAbsoluteDate(editedAt)}
        </span>
      )}
    </div>
  );
}
